function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "solid"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 280,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 328,
  r: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "m368 232a16 16 0 1 0 -29.615 8.362 8.019 8.019 0 0 1 5.253 5.253 15.967 15.967 0 0 0 24.362-13.615z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m184 400h144v-144h-144zm120-8a8 8 0 1 1 8-8 8 8 0 0 1 -8 8zm0-128a8 8 0 1 1 -8 8 8 8 0 0 1 8-8zm-96 0a8 8 0 1 1 -8 8 8 8 0 0 1 8-8zm48 8a56 56 0 1 1 -56 56 56.063 56.063 0 0 1 56-56zm-48 104a8 8 0 1 1 -8 8 8 8 0 0 1 8-8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m256 368a40 40 0 1 0 -40-40 40.045 40.045 0 0 0 40 40zm0-64a24 24 0 1 1 -24 24 24.028 24.028 0 0 1 24-24z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 216,
  r: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "m200 432h9.754l4-16h-13.754z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m190.987 240h17.013v-56h-96v176h56v-17.022a32 32 0 1 1 0-61.948v-18.043a31.986 31.986 0 1 1 22.987-22.987zm-54.987 104a8 8 0 1 1 -8-8 8 8 0 0 1 8 8zm-8-136a8 8 0 1 1 8-8 8 8 0 0 1 -8 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m302.246 432h9.754v-16h-13.754z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m144 312a15.991 15.991 0 0 0 24 13.85v-27.708a16 16 0 0 0 -24 13.858z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m160 216a16 16 0 1 0 8.362 29.615 8.019 8.019 0 0 1 5.253-5.253 15.967 15.967 0 0 0 -13.615-24.362z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32 336h64v-224h-64zm32-208a24 24 0 1 1 -24 24 24.028 24.028 0 0 1 24-24zm0 64a24 24 0 1 1 -24 24 24.028 24.028 0 0 1 24-24zm0 64a24 24 0 1 1 -24 24 24.028 24.028 0 0 1 24-24z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 448,
  cy: 280,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 448,
  cy: 216,
  r: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "m368 312a16.019 16.019 0 0 0 -16-16 15.857 15.857 0 0 0 -8 2.152v27.706a16 16 0 0 0 24-13.858z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m416 112v224h64v-224zm32 192a24 24 0 1 1 24-24 24.028 24.028 0 0 1 -24 24zm0-64a24 24 0 1 1 24-24 24.028 24.028 0 0 1 -24 24zm0-64a24 24 0 1 1 24-24 24.028 24.028 0 0 1 -24 24z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 448,
  cy: 152,
  r: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "m32 352h64v80h-64z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 152,
  r: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "m304 240h17.013a31.986 31.986 0 1 1 22.987 22.987v18.029a32.007 32.007 0 1 1 0 61.954v17.03h56v-176h-96zm80 112a8 8 0 1 1 8-8 8 8 0 0 1 -8 8zm0-160a8 8 0 1 1 -8 8 8 8 0 0 1 8-8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m416 352h64v80h-64z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m193.892 105.774a88 88 0 0 1 124.452 0 8 8 0 0 0 11.312-11.314 104 104 0 0 0 -147.077 0 8 8 0 1 0 11.313 11.314z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m307.03 128.4a8 8 0 0 0 0-11.313 72 72 0 0 0 -101.823 0 8 8 0 0 0 11.314 11.313 56 56 0 0 1 79.2 0 8 8 0 0 0 11.309 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m227.833 139.716a8 8 0 0 0 11.314 11.314 24 24 0 0 1 33.941 0 8 8 0 0 0 11.312-11.314 40 40 0 0 0 -56.569 0z"
}));

function Svg66(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg66);
export default __webpack_public_path__ + "static/media/6_6.884e6c20.svg";
export { ForwardRef as ReactComponent };